<template>
  <div class="ad-recommend-cell">
    <template v-if="recommendation">
      <el-popover
        placement="bottom"
        width="300"
        trigger="click"
      >
        <div class="recommend-body">{{ recommendation.body }}</div>
        <div class="recommend-footer">
          <el-button
            v-if="!recommendation.adopted && recommendation.recommendId"
            type="primary"
            size="mini"
            :loading="adopting"
            @click="handleAdopt"
            >采纳</el-button
          >
          <el-tag
            v-if="recommendation.adopted"
            type="success"
            size="mini"
            >已采纳</el-tag
          >
        </div>
        <span
          slot="reference"
          class="lift-estimate"
          >{{ recommendation.lift_estimate }}</span
        >
      </el-popover>
    </template>
    <span
      v-else
      class="placeholder"
      >--</span
    >
  </div>
</template>

<script>
import { applyAdRecommend } from '@/api/adManagement';

export default {
  name: 'AdRecommendCell',
  props: {
    recommendation: {
      type: Object,
      default: null,
    },
    accountId: {
      type: String,
      default: '',
    },
    adId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      adopting: false,
    };
  },
  methods: {
    async handleAdopt() {
      if (!this.recommendation || !this.recommendation.recommendId) {
        this.$message.error('建议数据不完整');
        return;
      }
      this.adopting = true;
      try {
        const res = await applyAdRecommend(this.accountId, this.recommendation.recommendId);
        if (res.code === 0 && res.data && res.data.success) {
          this.$message.success('建议已成功采纳');
          this.$emit('adopt-success', {
            adId: this.adId,
            recommendId: this.recommendation.recommendId,
          });
          this.$set(this.recommendation, 'adopted', true);
        } else {
          this.$message.error(res.data?.message || '采纳建议失败，请稍后重试');
          this.$emit('adopt-error', {
            adId: this.adId,
            recommendId: this.recommendation.recommendId,
            error: res.data?.message,
          });
        }
      } catch (error) {
        console.error('采纳建议失败:', error);
        this.$message.error('采纳建议失败，请稍后重试');
        this.$emit('adopt-error', {
          adId: this.adId,
          recommendId: this.recommendation.recommendId,
          error: error.message,
        });
      } finally {
        this.adopting = false;
      }
    },
  },
};
</script>

<style scoped>
.ad-recommend-cell {
  padding: 4px 0;
}

.lift-estimate {
  color: #409eff;
  cursor: pointer;
  font-size: 13px;
}

.lift-estimate:hover {
  text-decoration: underline;
}

.recommend-body {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 12px;
}

.recommend-footer {
  text-align: right;
}

.placeholder {
  color: #909399;
}
</style>
